import { DocumentEntityType, mapDocumentEntityTypeToEntityType } from "@common/components/search/SearchResultList.types";
import { useEntityUrl } from "@common/components/documentPreview/DocumentPreviewHeader";

export function useEntityUrlForDocumentEntityType(entityType: DocumentEntityType | undefined, entityId: string | undefined): string | null {
    const mapped =
        entityType !== undefined && entityType !== DocumentEntityType.ConversationAttachment ? mapDocumentEntityTypeToEntityType(entityType) : undefined;
    return useEntityUrl(mapped, entityId);
}
